<section class="login">
	<div class="auth-block-wrapper">
		<div class="auth-block">
			<div class="card">
				<div class="card-body">
					<div class="logo">
						<a href=""
							><img
								src="@/assets/images/logo.png"
								alt="Legal Search Box"
						/></a>
					</div>
					<h4 class="card-title">Welcome to Legal Search Box</h4>
					<p class="card-text" v-if="maintenance"><br/><strong>Sorry For The Inconvenience</strong><br /><span @click="maintenance = false;">We</span> are currently upgrading our platform.<br />
						Hold tight, we've some amazing features on the way :)<br/><br/> System will be unavailable until: <br/><i>11am 16th of November</i></p>
					<p class="card-text" v-if="!maintenance">Please sign-in to your account</p>
					<form
						class="auth-form"
						@submit.prevent="login"
						v-if="!maintenance"
					>
						<div class="form-group">
							<label
								for="email"
								class="form-label"
								>Email</label
							>
							<input
								class="form-control"
								id="email"
								name="email"
								v-model="form.username"
								type="text"
								placeholder=""
								aria-describedby="email"
								tabindex="1"
								autofocus
								required
							/>
						</div>
						<div class="form-group mb-14">
							<div class="d-flex justify-content-between">
								<label
									class="form-label"
									for="password"
									>Password</label
								>
							</div>
							<div class="input-group input-group-merge form-password-toggle">
								<input
									class="form-control form-control-merge"
									id="password"
									name="password"
									v-model="form.password"
									type="password"
									tabindex="2"
									placeholder=""
									required
									aria-describedby="password"
								/> 
							</div>
						</div>
						<div class="form-group">
							<div class="remember-me">
								<input
									class="form-check-input"
									type="checkbox"
									id="remember-me"
									tabindex="3"
								/>
								<label
									class="form-check-label"
									for="remember-me"
								>
									Remember Me
								</label>
							</div>
							<div class="forgot-password">
								<router-link to="/forgot-password">Forgot Password?</router-link>
							</div>
						</div>
						<button
							class="form-button"
							tabindex="4"
							type="submit"
						>
							Login
						</button>
					</form>
					<p class="register-notes" v-if="!maintenance">
						<span>New on our platform?</span> &nbsp;

						<router-link to="/register">Create an account</router-link>
						
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
